export default "__VITE_ASSET__CsURspSZ__"